export default __webpack_public_path__ + "static/child-eating-7d2206d556169e0dc6539e47325be7cb.jpg";